module.exports = __webpack_public_path__ + "static/media/loadingGear.cc3d1b64.svg";